export default {
  loadingCount: 1,
  accountInfoLoading: true,
  companyType: null,
  selectedFeatures: [],
  fbSdkLoaded: false,
  appVersion: process.env.APP_VERSION,
  toast: false,
  toastText: '',
  toastTimeout: 3000,
  toastColor: 'toast_default',
  saverbarActive: false,
  saveChanges: false,
  cancelChanges: false,
  toolbarActive: true,
  toolbarTitle: '',
  accountInfo: {
    //the rest is loaded from the API
    mainThemeWidget: '',
    mainThemeProduct: '',
    mainThemeList: '',
    mainThemeCarousel: '',
    mainThemeFooter: '',
    featuredReviewCounter: 0,
    annualUrl: 'www.shopify.com',
    billingDate: '',
    facebookPageId: '',
    exclusivePlans: [],
    extensionAuthToken: '',
    extensionMassImport: 0,
    importsAutomaticSync: false,
    importedReviewAutoApprove: true,
    importerProfiles: {},
    shopCurrency: 'USD',
    shopCurrencyExchangeRate: 1,
    shopSubscriptionCurrency: 'USD',
    planId: 0,
    shopId: 0,
    shopPlatformId: 0,
    planName: '',
    planPrice: 0,
    planType: 'month',
    shopifyPlanName: '',
    logoUrl: '',
    reviewImportQuotaTotal: 0,
    reviewImportQuotaLeft: 0,
    creditsLeft: 0,
    smsCreditsLeft: null,
    monthlySmsCredits: null,
    numRatings: 0,
    shopDomain: '',
    visibleDomain: '',
    shopOwnerEmail: '',
    shopOwnerName: '',
    serverUrl: '',
    trialDaysLeft: 0,
    shopifyOrdersCount: 0,
    smartReviewsAllowedPlans: [],
    bazaarvoiceAllowedPlans: [],
    shopifyProductsCount: 0,
    integrations: [],
    googleShoppingFeedUrl: '',
    googleShoppingIncludeAll: true,
    googleShoppingActive: false,
    googleShoppingSkuAsGtin: false,
    showFreePlanOffer: false,
    shownWidgetInstallationErrorBar: true,
    shopNeedsToChoosePlan: false,
    shopName: '',
    permissions: [],
    permissionMapping: {},
    onboardingSteps: {},
    plansAvailable: [],
    shopReviewStats: {},
    creditsPricingRules: [],
    isLargeShop: false,
    incentives: {
      extraReviewRequests: 0,
      extraImportQuota: 0,
    },
    isDevelopmentStore: false,
    aftershipPreferences: {
      apiKey: null,
      enabled: null,
      postDeliveryDays: null,
    },
    klaviyoPreferences: {
      publicToken: null,
      privateToken: null,
      listId: null,
      enabled: null,
      enableTesting: null,
      feedEnabled: null,
      sendReviewRequestKlaviyo: null,
      klaviyoStarsColor: null,
    },
    gorgiasPreferences: {
      user: null,
      domain: null,
      key: null,
      enabled: null,
      ticketStars: null,
      importedReviewsTicketGorgias: null,
    },
    zendeskPreferences: {
      user: null,
      domain: null,
      password: null,
      apiKey: null,
      enabled: null,
      ticketStars: null,
      importedReviewsTicketZendesk: null,
    },
    omnisendPreferences: {
      apiKey: null,
      enabled: null,
      sendReviewRequestOmnisend: null,
    },
    salesforcePreferences: {
      enabled: null,
      baseUrl: null,
      clientId: null,
      clientSecret: null,
      customNotificationId: null,
      password: null,
      username: null,
    },
    loyaltylionPreferences: {
      enabled: null,
      token: null,
      secret: null,
    },
    smileIoPreferences: {
      enabled: null,
      clientToken: null,
      activityToken: null,
    },
    bazaarvoicePreferences: {
      bazaarvoiceName: null,
    },
    riseAiPreferences: {
      enabled: null,
      riseAiLeftReviewUrl: null,
      riseAiLeftReviewPayload: null,
    },
    limespotActive: null,
    integrationShopifyFlowActive: null,
    wiserActive: null,
    excludeImportedReviewsGoogleMerchantFeed: false,
    mergeTagsPerTemplate: {},
    uiShowExtensionAnalytics: true,
    uiShowTalkToExprerts: true,
    uiShowRequestShopifyReviewModal: false,
    unansweredCount: 0,
    unpublishedCount: 0,
    activeAddons: [],
    addonsAvailable: {},
    smartReviewsPricing: {},
    lastYearTotalOrderValue: 0,
    shopLeftAppstoreReview: false,
    referralOfferCode: null,
    referralOfferLink: null,
    onboardingOffer: null,
    onboardingOfferEnabled: null,
    referredShops: [],
    referredLeaders: [],
    noReviewsUsersGuideCount: 0,
    referralEmailContent: null,
    shopCreationDate: null,
    totalImportedReviewsCount: 0,
    installationWithNewWidgets: null,
    showEnterpriseUpgradeButton: null,
    smartReviewsUpsellOffer: null,
    smartReviewsUpsellOfferRedeemed: null,
    smartReviewsUpsellOfferActive: null,
    smartReviewsUpsellOfferExpiryDate: null,
    writeCustomersScope: false,
    user: {
      name: '',
      email: '',
      shopsManaged: [],
    },
    getStartedSteps: null,
    showRatings: true,
    advancedEmailEditorUnlocked: false,
  },
  metafieldsData: {
    widgetGlobalConfig: '',
    widgetProductData: '',
    widgetBadgeData: '',
  },
  installationInfo: {
    installing: false,
    installingListStarsSuccess: false,
    installingProductStarsSuccess: false,
    installingProductWidgetSuccess: false,
    finishedAutomateReviews: true,
    finishedImportReviews: true,
    finishedCustomizeWidget: true,
    finishedSetupCoupon: true,
    finishedReviewUsOnAppStore: true,
    wizardIncentiveOffer: 'quota',
    shopifyProductsCount: 0,
    currentProductsCount: 0,
    shopifyOrdersCount: 0,
    currentOrdersCount: 0,
  },
  globalVars: {
    installationDataInterval: null,
    showPlanPickerDialog: false,
  },
  smsPlans: [],
  smsSettings: {
    sendReviewRequestsSms: false,
    smsPriceLimit: 0,
    smsSpentThisMonth: 0,
  },
  smsConfirmLink: '',
  smartReviewsData: {
    preview: null,
    pluginTestActive: false,
    testData: null,
    upsellOffer: {},
  },
  extension: {
    active: false,
    version: null,
  },
  orderPrinterTemplateCode: null,
};
